import React from 'react';
import { withPrefix } from 'gatsby';
import HeadAdv from '@economist/fabric-components/header/headadv/HeadAdv';
import styles from './HeadAdvLogo.styles';

const HeadAdvLogo = ({ logo, className, ...styleProps }) => (
  <div css={styles(styleProps)}>
    <div className="HeadAdv-logo">{logo && <HeadAdv sponsors={[{ sponsorLogo: withPrefix(logo) }]} />}</div>
  </div>
);

export default HeadAdvLogo;
